<template>
	<div class="tcp-page tcp-info">
		<section class="tcp-info__hero">
			<p class="tcp-kicker">Delivery</p>
			<h1>Shipping Information</h1>
			<p>We offer flexible shipping options to get your wellness essentials to you as quickly as possible.</p>
		</section>

		<section class="tcp-info__body">
			<div class="tcp-info__block">
				<h2>Shipping Options</h2>
				<div v-if="options.length" class="tcp-ship__list">
					<article v-for="(option, index) in options" :key="option.id" class="tcp-ship__card">
						<span class="tcp-info__icon"><i class="fa" :class="icon(index)"></i></span>
						<div>
							<div class="tcp-ship__head">
								<h3>{{ option.name }}</h3>
								<strong v-if="option.price">{{ option.price }}</strong>
							</div>
							<p v-if="option.delivery_time" class="tcp-ship__time">{{ option.delivery_time }}</p>
							<p v-if="option.description">{{ option.description }}</p>
						</div>
					</article>
				</div>
				<p v-else-if="!loading" class="tcp-empty">Shipping options will appear here once they are added.</p>
			</div>

			<div class="tcp-info__block">
				<h2>Processing Time</h2>
				<p>All orders are processed within <strong>1–2 business days</strong> (Monday–Friday, excluding holidays). Orders placed after 12PM CST may be processed the following business day.</p>
				<p>You will receive a shipping confirmation email with a tracking number once your order has been dispatched.</p>
			</div>

			<div class="tcp-info__block">
				<h2>Where We Ship</h2>
				<div class="tcp-ship__place">
					<span class="tcp-info__icon tcp-info__icon--muted"><i class="fa fa-map-marker"></i></span>
					<div>
						<p class="tcp-ship__place-name">United States</p>
						<p>We ship to all <strong>50 US states</strong>, including Alaska and Hawaii (additional charges may apply). Delivered via USPS, UPS, or FedEx.</p>
					</div>
				</div>
				<div class="tcp-ship__place">
					<span class="tcp-info__icon tcp-info__icon--muted"><i class="fa fa-map-marker"></i></span>
					<div>
						<p class="tcp-ship__place-name">Mexico</p>
						<p>We ship throughout the <strong>32 states of Mexico</strong> via Estafeta, DHL, or FedEx. Major metro areas like Mexico City, Guadalajara, and Monterrey typically enjoy faster delivery. Remote areas may require 1–2 additional business days.</p>
					</div>
				</div>
			</div>

			<div class="tcp-info__block">
				<h2>Tracking Your Order</h2>
				<p>Once your order ships, you will receive a tracking number via email. You can use it directly on the carrier's website (USPS, UPS, FedEx, Estafeta, or DHL depending on your region).</p>
			</div>

			<div class="tcp-info__note">
				<h2>Having an issue with your delivery?</h2>
				<p>If your package is delayed, lost, or damaged in transit, please reach out to us. We'll work with the carrier to resolve the issue as quickly as possible.</p>
				<router-link to="/contact">Contact our support team</router-link>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: [],
			loading: true
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/shipping')).then((response) => {
			this.options = response.data || []
			this.loading = false
		}).catch(() => {
			this.loading = false
		})
	},
	methods: {
		icon(index) {
			return ['fa-truck', 'fa-clock-o', 'fa-cube'][index % 3]
		}
	}
}
</script>
